export const fetchOperationalDashboardUsersUrl = `/dashboard/users`;
export const fetchOperationalDashboardAreasUrl = `/dashboard/filters`;
export const fetchOperationalDashboardNotificationsUrl = `/dashboard/notifications`;
export const fetchOperationalDashboardSalesUrl = `/dashboard/sales`;
